import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import './Button.css';
import COS_LOADING from '../../images/COS_LOADING.svg';

const Button = ({
  children,
  onClick,
  type = 'submit',
  grey,
  green,
  greenLight,
  classname,
  disabled = false,
  loading = false,
}) => {
  return (
    <button
      className={clsx(`Button ${classname}`, {
        'Button--grey': grey,
        'Button--green': green,
        'Button--green-light': greenLight,
      })}
      onClick={onClick}
      type={type}
      disabled={disabled || loading}
    >
      {loading ? (
        <img className="Button__loading-icon" src={COS_LOADING} alt="loading" />
      ) : (
        children
      )}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  type: PropTypes.string,
  small: PropTypes.bool,
  medium: PropTypes.bool,
  large: PropTypes.bool,
  green: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
};

export default Button;
